import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import "./AddedToday.css";

const TABS = [
  { key: "Office",      label: "Office Spaces",      type: "Villa"  },
  { key: "Public",      label: "Public Spaces",       type: "Flat"   },
  { key: "Residential", label: "Residential Spaces",  type: "House"  },
  { key: "Commercial",  label: "Commercial Spaces",   type: "Plot"   },
];

const FALLBACK_IMG = "https://c4.wallpaperflare.com/wallpaper/575/667/599/trees-design-house-lawn-wallpaper-preview.jpg";

const PropertyCard = ({ property, assetUrl }) => {
  const imageUrl = property.images?.length > 0
    ? `${assetUrl}${property.images[0].image_url}`
    : FALLBACK_IMG;

  return (
    <div className="at__card">
      <img src={imageUrl} alt={property.title} className="at__card-img" />
      <div className="at__card-overlay" />
      <div className="at__card-body">
        <div className="at__card-badges">
          <span className="at__badge at__badge--verified">Verified</span>
          <span className="at__badge at__badge--new">New</span>
        </div>
        <div className="at__card-info">
          <p className="at__card-purpose">For {property.purpose?.name}</p>
          <h3 className="at__card-title">{property.title}</h3>
          <div className="at__card-footer">
            <p className="at__card-address">
              <MapPin size={12} />
              {property.area?.name}, {property.city?.name}
            </p>
            <span className="at__card-price">
              ₹ {property.budget?.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddedToday = () => {
  const [activeTab, setActiveTab]     = useState(TABS[0].key);
  const [properties, setProperties]   = useState([]);
  const [assetUrl, setAssetUrl]       = useState("");
  const [loading, setLoading]         = useState(true);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const currentType = TABS.find((t) => t.key === activeTab)?.type;

  const fetchProperties = useCallback(async (type) => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}/all/property/list/all/purpose`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          page_number: 1,
          page_size: 4,
          order_by: "ASC",
          type,
        }),
      });
      const data = await response.json();
      if (data.statusType === "SUCCESS") {
        setProperties(data.properties);
        setAssetUrl(data.assetUrl);
      } else {
        setProperties([]);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
      setProperties([]);
    } finally {
      setLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchProperties(currentType);
  }, [currentType, fetchProperties]);

  return (
    <section className="at">
      <div className="at__container">

        <div className="at__header">
          <div>
            <span className="at__label">Fresh listings</span>
            <h2 className="at__title">Added <em>Today</em></h2>
          </div>
          <Link to="/property-list" className="at__view-all">
            View all <ArrowRight size={14} strokeWidth={2.5} />
          </Link>
        </div>

        <div className="at__tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`at__tab ${activeTab === tab.key ? "at__tab--active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="at__grid">
          {loading ? (
            <div className="at__empty">Loading properties…</div>
          ) : properties.length === 0 ? (
            <div className="at__empty">No properties found.</div>
          ) : (
            properties.map((property) => (
              <PropertyCard key={property.id} property={property} assetUrl={assetUrl} />
            ))
          )}
        </div>

      </div>
    </section>
  );
};

export default AddedToday;